import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers, FormikProps } from "formik";
import { setDateFilter, setStatus } from "src/redux/slices/RecordingRequestSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import FilterRecordingRequestDialog from "./FilterRecordingRequestDialog";

type Props = {
  onClose: () => void;
};

export type RecordingRequestFilterCardValue ={
  startDate: any;
  endDate: any;
  status : any
}

const FilterRecordingRequestDialogWrapper = ({ onClose }: Props) => {
  const dispatch = useDispatch();
  const { dateFilter , status  } =
  useSelector((state: RootState) => state.recordingRequest);

  // Form Initial Values
  const initialValues: RecordingRequestFilterCardValue = {
    startDate: dateFilter?.start_date || null,
    endDate:dateFilter?.end_date || null,
    status :status, 
   }
 

  // Handle Submit
  const handleSubmit = (
    values: RecordingRequestFilterCardValue,
    { setSubmitting, resetForm }: FormikHelpers<RecordingRequestFilterCardValue>
  ) => {
    dispatch(
      setDateFilter({
        start_date: values?.startDate,
        end_date: values?.endDate,
      })
    );
    dispatch(setStatus(values?.status))
   setSubmitting(false) 
   onClose()
  };
  const handleReset = (formikProps: FormikProps<RecordingRequestFilterCardValue>) => {
    dispatch(setDateFilter({
      start_date:null,
      end_date: null,
    })) ;
    dispatch(setStatus('')) ;}

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
       
      >
        {(formikProps) => (
          <Form>
            <FilterRecordingRequestDialog formikProps={formikProps} onClose={onClose}  onReset={handleReset}  />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default FilterRecordingRequestDialogWrapper;
